"use strict";
import React from "react";
export default function NotFound() {
  return /* @__PURE__ */ React.createElement("div", null, "The route is not exist(404)");
}
